console.log('T');

jQuery(document).ready(function(){
  // jQuery('.social_media a').hover(function() {
  //     console.log('tests');
  //     // Hide the first image and display the second image
  //     jQuery(this).find('.smicon').hide();
  //     jQuery(this).find('.smicon-new').show();
  //   }, function() {
  //     // When mouse leaves, revert the changes
  //     jQuery(this).find('.smicon').show();
  //     jQuery(this).find('.smicon-new').hide();
  //   });
});